module.exports = __webpack_public_path__ + "static/media/iconupload.f2baf3cf.svg";